import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack, Select, MenuItem } from "@mui/material";

import CachedIcon from "@mui/icons-material/Cached";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";

import InvoiceHistory from "./component/T_InvoiceHistory";

import useGeneral from "../../../hooks/super/useGeneral";
import useAuth from "../../../hooks/useAuth";
import { CollapseAlert } from "../../../components/pages/common/styled";

import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";
import {
  TOKENS,
  StatTile,
} from "../../../components/pages/_new/super/design";

function SAInvoiceConfiguration() {
  const { getInvoiceHistory, getOrganisations, size, errMsg, setErr, invoices } = useGeneral();
  const { isAuthenticated } = useAuth();

  const [orgs, setOrgs] = React.useState();
  const [curOrg, setCurOrg] = React.useState();

  React.useEffect(() => {
    async function getOrgs() {
      setOrgs(await getOrganisations());
    }
    if (isAuthenticated) {
      getOrgs();
    }
    return () => setErr(null);
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (orgs === null || orgs === undefined) return;
    if (orgs.length === 0) setErr("There are no organisations. Please add new organisation first.");
    setCurOrg(orgs[0]?.id);
  }, [orgs]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectOrgID = (event) => setCurOrg(event.target.value);
  React.useEffect(() => {
    if (curOrg === null || curOrg === undefined) return;
    getInvoiceHistory(curOrg, size, 0);
  }, [curOrg]); // eslint-disable-line react-hooks/exhaustive-deps

  const refresh = () => {
    if (curOrg === null || curOrg === undefined) return;
    getInvoiceHistory(curOrg, size, 0);
  };

  const [errOpen, setErrOpen] = React.useState(false);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  const totalInvoices = Array.isArray(invoices) ? invoices.length : 0;

  return (
    <React.Fragment>
      <Helmet title="SA General Configuration" />
      <PageHeader
        title="Invoice History"
        description="Browse invoice history per tenant organisation"
        actions={
          <OutlinedButton onClick={refresh} startIcon={<CachedIcon style={{ width: 18, height: 18 }} />}>
            Refresh
          </OutlinedButton>
        }
      />
      <Box sx={{ mb: 3 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
          gap: 2,
          mb: 3,
        }}
      >
        <StatTile icon={<ReceiptLongIcon />} value={totalInvoices} label="Invoices on this page" />
        <StatTile
          icon={<ReceiptLongIcon />}
          iconBg={TOKENS.infoBg}
          iconInk={TOKENS.infoInk}
          value={orgs?.length || 0}
          label="Organisations"
        />
      </Box>

      <Box
        sx={{
          border: `1px solid ${TOKENS.border}`,
          borderRadius: `${TOKENS.radiusM}px`,
          background: TOKENS.bgSurface,
          boxShadow: TOKENS.shadowXs,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: "14px 16px",
            borderBottom: `1px solid ${TOKENS.borderSubtle}`,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexWrap: "wrap",
          }}
        >
          <Select
            value={curOrg !== null && curOrg !== undefined && curOrg}
            onChange={selectOrgID}
            size="small"
            sx={{
              minWidth: 280,
              "& .MuiOutlinedInput-input": { fontSize: 13.5 },
              borderRadius: "10px",
              background: TOKENS.bgSurface,
            }}
          >
            {orgs?.map((org) => (
              <MenuItem key={org.id} value={org.id}>
                {org.title}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box sx={{ p: 0 }}>
          <Stack spacing={0}>
            <InvoiceHistory curOrg={curOrg} />
          </Stack>
        </Box>
      </Box>
    </React.Fragment>
  );
}
export default SAInvoiceConfiguration;
